import { render, staticRenderFns } from "./r-smart-offer-page.vue?vue&type=template&id=84aa095e"
import script from "./r-smart-offer-page.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-page.vue?vue&type=script&lang=js"
import style0 from "./r-smart-offer-page.vue?vue&type=style&index=0&id=84aa095e&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84aa095e')) {
      api.createRecord('84aa095e', component.options)
    } else {
      api.reload('84aa095e', component.options)
    }
    module.hot.accept("./r-smart-offer-page.vue?vue&type=template&id=84aa095e", function () {
      api.rerender('84aa095e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/r-smart-offer-page.vue"
export default component.exports